import React, { useEffect, useState } from "react";
import { isReactAppAuthorized, cacheManager, clearAzureAdAuthCodeAction, encrypt, allowPermissionForAuth, filterPermissionUrl, getMethodForPermissionType } from "../helpers/util-common";
import { SHOW_NOT_FOUND_PAGE, HIDE_NOT_FOUND_PAGE } from "../action-type";
import { useDispatch, useSelector } from "react-redux";
import { validateNavigationFromUrl } from "../helpers/util-common";
import { getActiveCommitteesAction, getAllBallotStatusAction, getAllCommitteesAction, getBallotDesignationAction, getDraftListAction, getStandardMaintDesignationListAction } from "../redux/action/ballots";
import { getWorkItemStatusAction, getWorkItemsAction } from "../redux/action/workItem";
import "./_layoutScreen.scss";
import { useLocation, useNavigate } from "react-router-dom";
import lodash,{ isEmpty, uniq } from "lodash";
import HeaderMenu from "../shared-components/Header/header";
import Breadcrumb from "../shared-components/breadcrumb";
import Navigation from "../navigation/navigation";
import * as commonActions from "../common.actions";
import { getWorkItemListAction } from "../redux/action/workItem";
import { LEFT_NAVIGATION_PAGE_URL } from "../models/navigation.models";
import { getPermissionOnPageAction, setPermissionData } from "../common.actions";
import { AdvanceSearchFormType } from "../models/common.models";
import { setselectedWITN } from "../workitem.actions";
import { PERMISSION_NAVIGATION } from "../../common.enum";
import { WITNItem } from "../pages/WorkItems/interface";

export const Layout = () => {
  const history = useLocation();
  let navigate = useNavigate();
  type Option = {
    text: string;
    value: string;
    key: string;
  };
  const dispatch = useDispatch();
  const [committeeData, setCommitteeData] = useState<Array<any>>([]);
  const [currentAction, setCurrentAction] = useState<string>('');
  const [ballotDesignationData, setBallotDesignationData] = useState<Array<any>>([]);
  const [wiListData, setWIListData] = useState<Array<any>>([]);
  const [witnListData, setWITNListData] = useState<Array<any>>([]);
  const [standardListData, setStandardListData] = useState<Array<any>>([]);
  const [ballotStatusOption, setBallotStatusOption] = useState<Option[]>([{ text: "All", value: "All", key: "all" }]);
  const [wiStatusOption, setWIStatusOption] = useState<Option[]>([{ text: "All", value: "All", key: "all" }]);
  const [resetClicked, setResetClicked] = useState<boolean>(false);
  const workLitemResponse = useSelector((state: any) => state.commonReducer.workItemList);
  const [committeeList, setCommitteeList] = useState([]);
  const [searchText,setSearchText]=useState("");
  const [searchFlow, setSearchFlow] = useState("");
  const allCommittees = useSelector((state: any) => state.commonReducer.allCommittees);
  const userPermission = useSelector((state: any) => state.commonReducer.userPermission);
  const [isPermissionSet, setIsPermissionSet] = useState(false); 

  useEffect(() => {
    getAllBallotStatus();
    getCommitteeList();
    !allCommittees.length && getAllCommitteesAction(dispatch);
  }, []);

  const loadAdvanceSearchData = (flow: string) => {
    if (flow === "workitem") {
      loadWIListData();
      loadWITNListData();
      loadStandardListData();
      getAllWIStatus()
    } else {
      loadBallotData();
    }
  }

  // This code will be used when the permissions are added in the code
  const validateBreadcrumbsUrls = () => {
    if (history.pathname === "/" && isReactAppAuthorized()) {
      window.history.pushState({}, "", "/ballot");
      window.location.reload();
    }

    let currentPath = window.location.pathname?.split("/")[1]== history.pathname?.split("/")[1]? PERMISSION_NAVIGATION[history.pathname?.split("/")[1]]:
    PERMISSION_NAVIGATION[window.location.pathname?.split("/")[1]];

    // this code will be remove when the permission is implemented for all the modules
    if (!currentPath) {
      currentPath = "ballot";
    }
    let urlDetails = validateNavigationFromUrl(currentPath);
    if (!urlDetails) {
      dispatch({ type: SHOW_NOT_FOUND_PAGE }); // IF Routes Not Matched
    } else {
      dispatch({ type: HIDE_NOT_FOUND_PAGE });
    }
    if (lodash(urlDetails).get("selectedSingleResult", null) && lodash(urlDetails).get("selectedSingleResult").length > 0) {
      let navUrlResult = lodash(urlDetails).get("selectedSingleResult")[0];
      // checkGetPermissionRequestFromUrl(navUrlResult);
      dispatch(getPermissionOnPageAction(navUrlResult, lodash(urlDetails).get("selectedFullResult", null)));
    }
    setIsPermissionSet(true);
  };
  useEffect(() => {
    validateBreadcrumbsUrls();
  }, [window.location.pathname]);
  useEffect(() => {
    if (isPermissionSet) {
      dispatch(setPermissionData({ loading: false }));
    }
  }, [isPermissionSet, userPermission]);

  const props = useSelector((state: any) => {
    return {
      currentLocation: state.commonReducer.currentRequest,
      documentStatusByCategory: state.commonReducer.documentStatusByCategory,
      showNotFoundPage: state.commonReducer.showNotFoundPage,
      ballotAdvanceSearchFormData: state.commonReducer.ballotAdvanceSearchFormData,
      wiAdvanceSearchFormData: state.commonReducer.wiAdvanceSearchFormData,
      quickSearchSelectedUser: state.commonReducer.quickSearchSelectedUser,
      isUserOfficer: state.commonReducer.isUserOfficer,
      wiExtraField : state.commonReducer.WorkItemExtraFields.filter(Boolean)
    };
  });
  const isUserAuthorized = isReactAppAuthorized();
  const getCommitteeList = () => {
    getActiveCommitteesAction(dispatch, (response: any) => {
      if (response && response.length > 0) {
        const CommitteeList = uniq(response.map((item: { CommitteeDesignation: any }) => item.CommitteeDesignation));
        setCommitteeList(response);
        setCommitteeData(CommitteeList);
      }
    });
  };

  const loadBallotData = () => {    
    if (ballotDesignationData.length) {
      return;
    }
    getBallotDesignationAction(dispatch, (response: any) => {
      if (!isEmpty(response)) {
        const sortedBallotDesignationData = response;
        const ballotDesignationList = uniq(sortedBallotDesignationData.map((item) => item.BallotDesignation));
        setBallotDesignationData(ballotDesignationList);
      }
    });
  };
  const loadWIListData = () => {
    if (wiListData.length) {
      return;
    }
    const req = {"WorkItemIds": [],"WorkItemNumbers":[]}
    getWorkItemsAction(req, dispatch, (response: any) => {
      if (!isEmpty(response)) {
        const sortedWIListData = response;
        const wiList = uniq(sortedWIListData.map((item: { WorkItemCategory:any, WorkItemNumber: any }) => item.WorkItemCategory + item.WorkItemNumber  ));
        setWIListData(wiList);
      }
    });
  };

  const loadWITNListData = () => {
    if (witnListData.length) {
      return;
    }
    const req = { DraftNumber: "" };
    getDraftListAction(req, dispatch, (response: any) => {
      if (!isEmpty(response)) {
        const sortedWITNListData = response;
        const witnList = sortedWITNListData.filter((item: WITNItem) => item.WITN?.trim() !== "").map((item: WITNItem) => item.WITN);
        setWITNListData(witnList);
      }
    });
  };

  const loadStandardListData = () => {
    if (standardListData?.length) {
      return;
    }
    getStandardMaintDesignationListAction(null, dispatch, (response: any) => {
      if (!isEmpty(response)) {
        const sortedStandarListData = response;
        const standarListData = sortedStandarListData.map(
          (item: { DisplayDesignationNumber: string; StandardDesignationNumber: string, StandardDesignationMetric: string }) => ({
            label: item.DisplayDesignationNumber +  (item.StandardDesignationMetric ?? ''),
            searchValue: item.StandardDesignationNumber +  (item.StandardDesignationMetric ?? ''),
          })
        );
        setStandardListData(standarListData);
      }
    });
  };

  const onGlobalSearchSubmit = (currentSearchOption: any, currentSearchText: any) => {    
    setSearchText(currentSearchText);
    setSearchFlow(currentSearchOption);
    if (!currentSearchText) {
      navigate(currentSearchOption)
    }
    const data = {
      "pageNumber": 1,
      "pageSize": workLitemResponse.paginationModel?.PageSize || 10,
      "sortColumnWithOrder": {
        "ModifiedDate": 2,
      },
      "UserEmail":props.quickSearchSelectedUser ? props.quickSearchSelectedUser : "",
      "WorkItemGlobalSearch": currentSearchText,
      "ExtraFields": props.wiExtraField
    }
    if(currentSearchOption == "workitem") {
      getWorkItemListAction(dispatch,data, (Result: any) => {
        if (!currentSearchText || !Result?.Data) {
            return;
          }
          const workItem = Result.Data.find(
            (item: any) => currentSearchText.toLowerCase().includes(item.WorkItemCategory?.toLowerCase()+item.WorkItemNumber?.toLowerCase())
          );
          if (!workItem) {
            navigate(currentSearchOption);
            return;
          }
        const dataToEncrypt = {
          FormattedStandardDesignation: workItem.FormattedStandardDesignation,
          DisplayDesignationNumber: workItem.DisplayDesignationNumber,
          StandardDesignationMetric: workItem.StandardDesignationMetric,
        };
        const encryptedData = encrypt(JSON.stringify(dataToEncrypt));

          const workItemCode = encrypt(`${workItem.WorkItemId}`);
          if (currentSearchText.includes("-")) {
            const witnList = workItem?.WITN?.split('|');
            const witnText = witnList?.find(witn => witn?.trim().toLowerCase().includes(currentSearchText.toLowerCase()));
            if (witnText) {
              dispatch(setselectedWITN(witnText?.trim()));
              navigate(`${LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL}/${(`${workItemCode}`)}/${workItem.WorkItemCategory}/${workItem.WorkItemNumber}?standardDesignationPageInfo=${encryptedData}`);
            }
          } else if (workItem) {
            navigate(`${LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL}/${(`${workItemCode}`)}/${workItem.WorkItemCategory}/${workItem.WorkItemNumber}?standardDesignationPageInfo=${encryptedData}`)
          }
        else{
            navigate(currentSearchOption)
          }
    });
    } else{
      navigate(currentSearchOption);
    }
    setCurrentAction('global');
    dispatch(commonActions.setGlobalSearchText(currentSearchText));
  };

  const onAdvanceSearchSubmit = (formData: any, type: string) => {
    setCurrentAction("advance");
    if (type == AdvanceSearchFormType.Ballot) {
      if (window.location.pathname !== "/ballot") {
        navigate("/ballot");
      }
      const selectedBallotStatus = formData?.selectedBallotStatus || "All";
      dispatch(commonActions.setQuickSearchSelectedBallotStatus(selectedBallotStatus));
      dispatch(commonActions.setBallotAdvanceSearch(formData));
    }
    if (type == AdvanceSearchFormType.Workitem) {
      if (window.location.pathname !== "/workitem") {
        navigate("/workitem");
      }
      const selectedWIStatus = formData?.selectedWIStatus || "All";
      dispatch(commonActions.setQuickSearchSelectedWorkItemStatus(selectedWIStatus));
    }
  };

  const setAdvBallotSearchFormData = (formData: any) => {
    dispatch(commonActions.setAdvBallotSearchFormData(formData));
  };

  const setAdvWorkitemSearchFormData = (formData: any) => {
    dispatch(commonActions.setAdvWorkitemSearchFormData(formData));
  };

  const userDetail = cacheManager.getItem("userDetail") && JSON.parse(cacheManager.getItem("userDetail"));

  if (!isUserAuthorized && !userDetail) {
    setTimeout(() => {
      window.location.assign(clearAzureAdAuthCodeAction());
    }, 500);
  }

  const getAllBallotStatus = () => {
    if (ballotStatusOption?.length > 1) {
      return;
    }
    getAllBallotStatusAction(dispatch, (response: any) => {
      if (response && response.length > 0) {
        const mappedOptions: Option[] = response.map((item) => ({
            text: item.BallotStatus,
            value: item.BallotStatus.toString(),
            key: item.BallotStatus.toLowerCase(),
        }));
          setBallotStatusOption([{ text: "All", value: "All", key: "all" }, ...mappedOptions]);
      }
    });
  };

  const getAllWIStatus = () => {
    if (wiStatusOption.length > 1) {
      return;
    }
    getWorkItemStatusAction(dispatch, (response: any) => {
      if (response && response.length > 0) {
        const mappedOptions: Option[] = response.map((item) => ({
            text: item.WorkItemStatus,
            value: item.WorkItemStatusId.toString(),
            key: item.WorkItemStatus.toLowerCase(),
        }));
          setWIStatusOption([{ text: "All", value: "All", key: "all" }, ...mappedOptions]);
      }
    });
  };

  const updateQuickSearchUser = () => {
    dispatch(commonActions.setQuickSearchSelectedUser("akumar"));
  }

  const setIsUserOfficer = (flag: boolean) => {
    dispatch(commonActions.setIsUserOfficer(flag));
  }

  const setGlobalSearchReset = () => {
    setResetClicked(true);
    dispatch(commonActions.setGlobalSearchText(""));
  }

  return (
    <>
      {isUserAuthorized ? (
        <div className="homePage" data-testid="layout_id">
          {userDetail && <HeaderMenu
            {...props}
            loadAdvanceSearchData={loadAdvanceSearchData}
            committeeData={committeeData}
            ballotDesignationData={ballotDesignationData}
            wiListData={wiListData}
            witnListData={witnListData}
            standardListData={standardListData}
            userDetail={userDetail}
            onGlobalSearchSubmit={onGlobalSearchSubmit}
            onAdvanceSearchSubmit={onAdvanceSearchSubmit}
            setAdvBallotSearchFormData={setAdvBallotSearchFormData}
            setAdvWorkitemSearchFormData={setAdvWorkitemSearchFormData}
            ballotStatusOption={ballotStatusOption}
            wiStatusOption={wiStatusOption}
            resetClicked={resetClicked}
            setResetClicked={setResetClicked}
            ballotAdvanceSearchFormData={props.ballotAdvanceSearchFormData}
            wiAdvanceSearchFormData={props.wiAdvanceSearchFormData}
          />}
            <>
              <Breadcrumb/>
              <Navigation
                isUserAuthorized={isUserAuthorized}
                ballotStatusOption={ballotStatusOption}
                wiStatusOption={wiStatusOption}
                quickSearchSelectedUser={props.quickSearchSelectedUser}
                updateQuickSearchUser={updateQuickSearchUser}
                currentAction={currentAction}
                setCurrentAction={setCurrentAction}
                setIsUserOfficer={setIsUserOfficer}
                committeeData={committeeList}
                allCommittees={allCommittees}
                isUserOfficer={props.isUserOfficer}
                setGlobalSearchReset={setGlobalSearchReset}
                searchFlow={searchFlow}
                permission={isPermissionSet}
              />
            </>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default Layout;
